import { Component, Inject } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common/common.service';
import { JobUsageComponent } from '../job-usage/job-usage.component';
import { TimeClockService } from 'src/app/services/time-clock/time-clock.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { Filter } from 'src/app/pages/filter/filter.model';
import * as moment from 'moment';
import { AppService } from 'src/app/services/app/app.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { PaginationInstance } from 'ngx-pagination';
import { JobInsightDetailsComponent } from '../job-insight-details/job-insight-details.component';

@Component({
    selector: 'app-job-insight',
    templateUrl: './job-insight.component.html',
    styleUrls: ['./job-insight.component.scss']
})
export class JobInsightComponent {
    displayedColumns: string[] = ['name', 'job', 'shifts-on-job', 'total-hours', 'view-job-uses'];
    public dataSource = new MatTableDataSource();
    public insightArr: any[] = [];
    public headerArr: any[] = ["Name", "Sub category", "Shifts on job", "Total Hours", ""];
    public insightType: string = 'users';
    public dateForm!: FormGroup;
    public isFilterShow: boolean = false;
    public filterArr: any[] = [
        { key_name: "First Name", key_val: "first_name", type: 'text' },
        { key_name: "Last Name", key_val: "last_name", type: 'text' },
        { key_name: "Email", key_val: "email", type: 'text' },
    ];
    public filterObj: Filter = {
        operand: "or",
        arr: []
    }
    public isSpinnerLoading = false
    public pageSizeOptions = GlobalService.pageSizeOptions;
    public maxPaginationSize = GlobalService.maxPaginationSize

    public objData = {
        user: {
            operand: "or",
            arr: [],
            isFilterShow: false,
            sh: "",
            previousInputValue: "",
            itemsPerPage: 12,
            currentPage: 1,
            maxPaginationSize: GlobalService.maxPaginationSize,
            count: 1,
        },
    };

    public searchInput: string = '';
    private previousInputValue: string = '';

    constructor(private commonService: CommonService, private dialog: MatDialog, private timeClockService: TimeClockService, private fb: FormBuilder,
        private datePipe: DatePipe, @Inject(MAT_DIALOG_DATA) public dialogData: any, public dialogRef: MatDialogRef<JobInsightComponent>,
        private appService: AppService, private spinner: NgxSpinnerService
    ) { }

    ngOnInit(): void {
        this.commonService.setTitle("Time Clock");
        // this.getList();
        this.dateForm = this.fb.group({
            start: ["", Validators.required],
            end: ["", Validators.required]
        })
        this.getDefaultDate();
        this.getList();
        this.dateForm.valueChanges.subscribe((res) => {
            //call the logic only if both start and end date is available
            if (res && this.dateForm.get('start')?.value && this.dateForm.get('end')?.value) {
                this.getList();
            }
        })
    }
    getDefaultDate() {
        // this function is used to get the last 15 days data, end date is the today's date
        let endDate = this.datePipe.transform(new Date(), "yyyy-MM-dd")
        var startdate;
        if (endDate) {
            startdate = moment().subtract(15, "days").format("yyyy-MM-DD");
        }
        this.dateForm.get('start')?.setValue(startdate);
        this.dateForm.get('end')?.setValue(endDate);
    }
    isControlHasError(controlName: string, validationType: string): boolean {
        return this.appService.isControlHasError(this.dateForm, controlName, validationType);
    }
    onViewJobUsage(item, employeeData) {

        const data = Object.assign(item, this.dialogData);
        data["first_name"] = employeeData.first_name;
        data["last_name"] = employeeData.last_name;
        data["email"] = employeeData.email;
        data["profile_picture"] = employeeData.profile_picture;
        data["em_i"] = employeeData.em_i;
        data["st_dt"] = this.datePipe.transform(this.dateForm.get('start')?.value, 'yyyy-MM-dd');
        data["ed_dt"] = this.datePipe.transform(this.dateForm.get('end')?.value, 'yyyy-MM-dd');
       
        const dialogRef = this.dialog.open(JobUsageComponent, {
            enterAnimationDuration: '300ms',
            exitAnimationDuration: "300ms",
            minWidth: '300px',
            width: '90%',
            height: '90%',
            data: data
            // maxHeight: '800px'
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) { }
            this.getList()
        });
    }
    getList() {
        let obj = {
            "tc_id": this.dialogData.params.id,
            "type": this.dialogData.params.type,
            "st_dt": this.datePipe.transform(this.dateForm.get('start')?.value, 'yyyy-MM-dd'),
            "ed_dt": this.datePipe.transform(this.dateForm.get('end')?.value, 'yyyy-MM-dd'),
            "j_c": this.dialogData.j_c,
            "sh": this.searchInput.trim(),
            "f_a": this.filterObj.arr,
            "op_nd": this.filterObj.operand,
            r_p: this.objData.user.itemsPerPage,
            st: this.appService.startPageLogic(
                this.objData.user.currentPage,
                this.objData.user.itemsPerPage
            ),
        }
        this.previousInputValue = this.searchInput.trim();
        if (this.insightType == "users") {
            obj["v_t"] = "1"
        }
        else {
            obj["v_t"] = "2"
        }
        this.dataSource = new MatTableDataSource()
        this.insightArr = [];
        this.isSpinnerLoading = true
        this.timeClockService.getJobInsightEmp(obj).subscribe({
            next: (success: any) => {
                if (success.status == 200) {
                    this.objData.user.count = success.count;
                    this.dataSource = new MatTableDataSource(success.msg);
                    this.insightArr = []
                    this.insightArr = success.msg;
                }
                this.isSpinnerLoading = false
            },
            error: (error: any) => {
                this.isSpinnerLoading = false;
                this.insightArr = []
                this.commonService.handleError(error);
            }
        })
    }

    // // Function to convert "HH:MM:SS" to seconds
    // convertTimeToSeconds(time: string): number {
    //     const [hours, minutes, seconds] = time.split(":").map(Number);
    //     return hours * 3600 + minutes * 60 + seconds;
    // }

    // // Function to convert seconds back to "HH:MM:SS"
    // convertSecondsToTime(seconds: number): string {
    //     const h = Math.floor(seconds / 3600).toString().padStart(2, "0");
    //     const m = Math.floor((seconds % 3600) / 60).toString().padStart(2, "0");
    //     const s = (seconds % 60).toString().padStart(2, "0");
    //     return `${h}:${m}:${s}`;
    // }

    onExportCSV() {
        this.spinner.show()
        let data: {} = {
            "tc_id": this.dialogData.params.id,
            "type": this.dialogData.params.type,
            "st_dt": this.datePipe.transform(this.dateForm.get('start')?.value, 'yyyy-MM-dd'),
            "ed_dt": this.datePipe.transform(this.dateForm.get('end')?.value, 'yyyy-MM-dd'),
            "j_c": this.dialogData.j_c,
            "v_t": this.insightType == "users" ? "1" : "2"
        }
        this.timeClockService.exportCSV(data).subscribe({
            next: (success: any) => {
                this.spinner.hide();
                this.appService.downloadFile(success.msg, 'sample_csv')
            },
            error: (error: any) => {
                this.commonService.handleError(error);
            },
        });
    }
    onSelectionChange(event) {
        if (this.insightType == "users") {
            this.headerArr = ["Name", "Sub category", "Shifts on job", "Total Hours", ""];
        }
        else {
            this.headerArr = ["Sub category", "Users", "Shifts on job", "Total Hours", ""];
        }
        this.getList();
        this.insightArr = this.insightArr.map((item) => {
            item.isExpanded = false;
            return item;
        })
    }
    onArrowClick(item, index) {
        this.insightArr[index].isExpanded = !this.insightArr[index].isExpanded;
    }
    onFilterView() {
        this.isFilterShow = !this.isFilterShow;
        if (!this.isFilterShow && this.filterObj.arr.length > 0) {
            this.filterObj.arr = [];
            this.getList();
        }
        // if (this.isFilterShow == true) { this.filterArr = [{ filter_value: '', contains: '', containsArr: [''] }] }
    }
    callApi(obj) {
        this.filterObj = obj;
        this.getList()
    }
    onSearch(event: any) {
        const inputValue = (event.target as HTMLInputElement).value;
        if (inputValue == '' && this.previousInputValue !== '') {
            //   this.config.currentPage=0
            this.getList();
        }
    }
    onGo() {
        if (this.searchInput.trim() != '') {
            this.getList();
            //   this.config.currentPage=0
        }
    }

    onPageSizeChange(event: Event, type: string) {
        const tar = event.target as HTMLInputElement;
        this.objData[type].itemsPerPage = Number(tar.value);
        this.objData[type].currentPage = 1;
        this.getList();
    }
    onPageChange(number: number, type: string) {
        this.objData[type].currentPage = number;
        this.getList();
    }

    onOpenDetails(element) {
        let obj = {
            st_dt: this.datePipe.transform(this.dateForm.get('start')?.value, 'yyyy-MM-dd'),
            ed_dt: this.datePipe.transform(this.dateForm.get('end')?.value, 'yyyy-MM-dd'),
            j_c: element.j_c,
            j_sc: element.j_sc,
            tc_id: this.dialogData?.params?.id,
        }


        const dialogRef = this.dialog.open(JobInsightDetailsComponent, {
            enterAnimationDuration: "300ms",
            exitAnimationDuration: "300ms",
            minWidth: "300px",
            width: "95%",
            height: "90%",
            maxWidth: "100%",
            data: obj,
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.getList();
            }
        });
    }

}
